export default __webpack_public_path__ + "5ed609a2cf69f10a05d810ce435bf053.png";